<template>
  <div
    @mouseover="moused = true"
    @mouseleave="moused = false"
    class="BgVideoPlayer"
  >
    <video
      :controls="!customControls"
      class="BgVideoPlayer__video"
      ref="videoRef"
      @click="togglePlay"
      :timeupdate="timeUpdate"
      @canplay="updatePaused"
      @playing="updatePaused"
      @pause="updatePaused"
    >
      <source :src="video" type="video/mp4" />
    </video>
    <div
      v-if="customControls"
      @click="togglePlay"
      :class="`BgVideoPlayer__player-holder ${
        moused && 'BgVideoPlayer__player-holder--moused'
      }`"
    >
      <div
        :class="`player ${!paused ? 'player--paused' : 'player--playing'}`"
      ></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
export default {
  name: "bg-video-player",
  props: {
    video: String,
    timeUpdate: Function,
    getRef: Function,
    newScrubberTime: Number,
    endScrubberTime: Number,
    propsTime: Number,
    updateMetaData: Function,
    customControls: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paused: true,
      moused: false,
    };
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.keyCode == 32) {
        this.togglePlay();
      }
    });
  },
  mounted() {
    this.$refs.videoRef.addEventListener("timeupdate", (e) => {
      this.timeUpdate(this.$refs.videoRef.currentTime);
      if (
        this.endScrubberTime &&
        this.$refs.videoRef.currentTime >= this.endScrubberTime
      ) {
        this.$refs.videoRef.currentTime = this.newScrubberTime;
        this.$refs.videoRef.pause();
      }
    });
    this.$refs.videoRef.addEventListener("loadedmetadata", () => {
      this.updateMetaData(this.$refs.videoRef);
    });
    this.getRef(this.$refs.videoRef);
  },
  watch: {
    propsTime(newValue) {
      this.$refs.videoRef.currentTime = newValue;
    },
    newScrubberTime(newValue) {
      this.$refs.videoRef.currentTime = newValue;
    },
  },
  methods: {
    togglePlay() {
      if (!this.$refs.videoRef.paused) {
        this.$refs.videoRef.pause();
      } else {
        this.$refs.videoRef.play();
      }
    },
    updatePaused(event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
    },
  },
};
</script>
